import { render, staticRenderFns } from "./trev-cool-table.vue?vue&type=template&id=55cdcf1a&"
import script from "./trev-cool-table.vue?vue&type=script&lang=js&"
export * from "./trev-cool-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports